import React, { HTMLAttributes } from 'react';

import cx from 'classnames';

import s from './BubbleBackgroundSection.module.scss';

interface IProps extends HTMLAttributes<HTMLElement> {
  variant?: string;
  mobileImageURL?: string;
  backgroundImageURL?: string;
}

const BubbleBackgroundSection: React.FC<IProps> = ({
  children,
  className,
  variant,
  mobileImageURL,
  backgroundImageURL,
  ...props
}) => {
  return (
    <>
      <style jsx>{`
        .page-banner {
          background-image: ${backgroundImageURL
            ? `url(${backgroundImageURL})`
            : 'none'};
        }

        @media (max-width: 768px) {
          .page-banner {
            background-image: url(${mobileImageURL || backgroundImageURL});
          }
        }
      `}</style>
      <section
        className={cx(
          s['bubble-background-section'],
          'page-banner',
          className,
          {
            [`bg-${variant}`]: variant,
          },
        )}
        {...props}
      >
        <div className={cx(s['bubble-background-section__front'])}>
          {children}
        </div>
        <div className={s['bubble-background-section__back']}>
          <span className={cx(s.bubble, s['bubble-1'])} />
          <span className={cx(s.bubble, s['bubble-2'])} />
          <span className={cx(s.bubble, s['bubble-3'])} />
        </div>
      </section>
    </>
  );
};

export default BubbleBackgroundSection;
